<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content#return-panel
        div.modal-body
          div.modal-body--title
            h5.text-center 此藥物存放於多藥盒，請選擇欲補充藥盒
          div.row(v-if="sameMedDrugStorage.length !== 0")
            div.col-6(v-for="storage in sameMedDrugStorage")
              div.cmpn-button(@click="setNextDrugStorage(storage)")
                p {{storage.device | readableDevice}}
                p {{storage.stock}} / {{storage.max_stock}}
                p 批號:
                  span(v-if="storage.patch_number !== '' && storage.patch_number !== null && storage.patch_number !== undefined") {{storage.patch_number}}
                  span(v-else) 未設定
        div.modal-footer
          div.btn(@click="cancel") 取消
</template>

<script>
import _ from 'lodash';

export default {
  props: ['drugStorageIds'],
  name: 'RefillSelection',
  components: {
  },
  data() {
    return {
      setUnusedDevice: false,
      emptyDeviceSelected: null,
    };
  },
  computed: {
    sameMedDrugStorage() {
      const drugStorages = [];
      this.drugStorageIds.forEach((id) => {
        drugStorages.push(this.$store.state.drugInDevice.allDrugInDevice[id]);
      });
      return drugStorages;
    },
  },
  methods: {
    setNextDrugStorage(drugStorage) {
      this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorage.id);
      this.$store.commit('DRUG_IN_DEVICE_USED', drugStorage.id);
      this.$store.dispatch('setDrug', drugStorage.medication.id);
      this.$emit('selectionDone');
    },
    cancel() {
      this.$emit('cancelSelection');
    },
  },
  filters: {
    readableDevice(device) {
      return `第${device.net.open_times}藥櫃 - ${device.net.row_id}層 - ${device.pos_row}列 - ${device.relative_col}行`;
    },
  },
};
</script>

<style lang="sass">
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);


.modal-dialog
  width: 500px !important
  
#return-panel
  border: 0px
  width: 100%
  .modal-body--title
    margin-bottom: 1.5rem
    color: black

.cmpn-button
  background-color: #FF3811
  width: 100%
  height: 100px
  color: white
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
  p
    margin: 0
  &:active
    -moz-box-shadow:    inset 0 0 20px #000000;
    -webkit-box-shadow: inset 0 0 20px #000000;
    box-shadow:         inset 0 0 20px #000000;

</style>



// WEBPACK FOOTER //
// RefillSelection.vue?4e9e4236